<template>

    <v-section name="Unsubscribe Group" :expanded="expanded">
        <v-menu>
            <v-menu-item v-for="group in groups"
                :key="group.id"
                :title="group.name"
                :active="action.unsub_group_id === group.id"
                @click.native="updateUnsubGroup(group)">
            </v-menu-item>
        </v-menu>
    </v-section>

</template>

<script>

import Section from './Section';

export default {

    components: {
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        action() {
            return this.$store.getters['builder/action'];
        },

        groups() {
            return this.project.unsub_groups;
        },

    },

    methods: {

        updateUnsubGroup(group) {
            let action = this.action
            this.$set(action, 'unsub_group_id', group.id);
            this.$store.commit('builder/setAction', action);
        },

    },

}

</script>